import { Box, Grid, Typography } from '@mui/material';
import { Fragment } from 'react';

import { AuditFieldGrid } from '@/components/audit/AuditFieldGrid';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AuditEntryData = Record<string, any>;

interface AuditComparisonProps {
  i18n?: Record<string, string>;
  oldAudit?: AuditEntryData;
  newAudit?: AuditEntryData;
}

export function AuditComparison({ oldAudit, newAudit, i18n }: AuditComparisonProps) {
  return (
    <Fragment>
      <Box sx={{ position: 'sticky', top: 296, backgroundColor: 'common.white' }}>
        <Grid container paddingTop={2} spacing={2}>
          <Grid size={6}>
            {oldAudit ? (
              <Typography variant="h6">
                {new Date(oldAudit.createdAt).toLocaleString()}
                <br />
                {oldAudit.user ? `${oldAudit.user.firstName} ${oldAudit.user.lastName}` : 'System'}
              </Typography>
            ) : null}
          </Grid>

          <Grid size={6}>
            {newAudit ? (
              <Typography variant="h6">
                {new Date(newAudit.createdAt).toLocaleString()}
                <br />
                {newAudit.user ? `${newAudit.user.firstName} ${newAudit.user.lastName}` : 'System'}
              </Typography>
            ) : null}
          </Grid>
        </Grid>
      </Box>

      <AuditFieldGrid i18n={i18n} newData={newAudit?.data} oldData={oldAudit?.data} />
    </Fragment>
  );
}
